export { NewsCard, NewsCard as default } from './NewsCard'
export * from './NewsRail'
